import React from 'react';
import { Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { IconDiscord } from '@/assets/sns';
import { createPopup, withHttp } from '@/utils';
import { useCurrentAddressInfo } from '@/hooks';

import { ActionWrapper, ActionProps } from './Wrapper';
import style from './index.module.scss';

export const DiscordMember = (props: ActionProps) => {
  const { data: action } = props;

  const { userInfo, isVerified } = useCurrentAddressInfo();

  const hasSnsBined = !!userInfo?.discord_id;

  const disableTip =
    props.disableTip ||
    (isVerified && !hasSnsBined ? (
      <Trans i18nKey="QuestCard_Task.snsAdd" values={{ label: 'Discord' }}>
        <NavLink to="/credit" className={style.addSns}>
          Add Discord Account
        </NavLink>
        to DeBank first.
      </Trans>
    ) : null);

  const handleClick = () => {
    createPopup({
      url: withHttp(action.data.action_url!),
      width: window.outerWidth / 2,
      height: window.outerHeight / 2,
    });
  };

  return (
    <ActionWrapper
      {...props}
      disableTip={disableTip}
      onActionClick={handleClick}
      avatar={<img src={IconDiscord} className={style.actionIcon} alt="action" />}>
      <Trans
        i18nKey="QuestCard_consts.discord"
        values={{ sns: `[${action.data.chat_name || ''}]` }}
      />
    </ActionWrapper>
  );
};
